import React, { useState, useEffect } from 'react';
import { browserHistory, Link } from 'react-router';
import moment from 'moment';
import _ from 'lodash';
import withTeam from '../common/withTeam';
import withLoader from '../common/withLoader';
import withNotify from '../common/withNotify';
import withTableName from '../common/withTableName';
import withOnline from '../common/withOnline';
import withProducts from '../common/withProducts';
import withGoBack from '../common/withGoBack';
import withCaseDer from '../common/withCaseDer';
import Bugsnag from '../helpers/bugsnag';
import threeDot from '../assets/images/three-dots.svg';
import {
  getTableCaseByCaseId,
  getVhnPpcValue,
  updateTableWiseCaseByCaseId,
  getHospitalByCustomerNo,
} from '../utils/db';
import {
  updateCase,
  uploadDgr,
} from '../utils/utils';
import CaseChangesNoLonger from './Models/CasesChangesNoLonger';
import ArrowRight from '../assets/images/arrow-right.png';
import XrayIcon from '../assets/images/radiology-box-outline.png';
import DollarSign from '../assets/images/dollarSign.png';
import AcmFlag from '../assets/images/flag.png';
import DerSubmit from './Models/DerSubmit';
import {
  getDERFlag,
  getTerritoryData,
  getUser,
  handleProductsButtonClick
} from '../common/globals';
import withDerModal from '../common/withDerModal.js';
import withReadCaseData from '../common/withReadCaseData.js';
import withSelectCaseId from '../common/withSelectCaseId';
import FFFIcon from '../assets/images/fff_90_90.png';
import ACMRightArrow from '../assets/images/right-arrowACM.png';
import FFFIconDark from '../assets/images/fff_90_90_dark.png';
import ACMRightArrowDark from '../assets/images/right-arrowACM_dark.png';
import withThemeColor from '../common/withThemeColor.js';

const CaseRow = (props) => {
  const [active, setActive] = useState(true);
  const [vhnValue, setVhnValue] = useState({});
  const [acmPlanned, setAcmPlanned] = useState([]);
  const caseChangesNoLonger = null;
  const [isDER, setisDER] = useState(false);
  const [isFFFVisable, setIsFFFVisable] = useState(false);
  const [hospitalUseCustCaseIDStatus, setHospitalUseCustCaseIDStatus] = useState(false);

  const _getDERFlagValue = async () => {
    try {
      const isDERValue = await getDERFlag();
      setisDER(isDERValue);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onRedirect = (event, path) => {
    try {
      const {
        setTableName, table, onRedirect, notify, data: {
          MRN, PatientID, id, CaseDate,
        }, onMrnPatientIdAdd, online
      } = props;
      setTableName(table);
      event.stopPropagation();
      if (path === '') {
        if ((MRN === null || MRN === '') && (PatientID === null || PatientID === '')) {
          if (new Date(CaseDate) > new Date()) {
            notify({
              type: 'error',
              message: 'You can\'t add or view products for a case in the future.'
            });
          } else {
            onMrnPatientIdAdd(id);
          }
        } else {
          if (online) {
            console.error('Unexpected Error.');
          } else {
            notify({
              type: 'error',
              message: 'You can\'t add or view product when offline.'
            });
          }
        }
      } else {
        onRedirect(path);
      }
      // path === ''
      //   ? ((MRN === null || MRN === '') && (PatientID === null || PatientID === ''))
      //     ? (new Date(CaseDate) > new Date())
      //       ? notify({
      //         type: 'error',
      //         message: 'You can\'t add or view products for a case in the future.'
      //       })
      //       : onMrnPatientIdAdd(id)
      //     : notify({
      //       type: 'error',
      //       message: 'You can\'t add or view product when offline.'
      //     })
      //   : onRedirect(path);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _getVhnPpcValue = async () => {
    try {
      const { data: { CustomerName } } = props;
      let vhnPpcValue = {};
      if (CustomerName !== null) {
        vhnPpcValue = await getVhnPpcValue(CustomerName);
      }

      if (typeof vhnPpcValue !== 'undefined') {
        setVhnValue(vhnPpcValue);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _getAcmPlanned = async () => {
    try {
      const { data: { ACMPlannedParts } } = props;
      const plannedArr = [];
      if (ACMPlannedParts !== null) {
        const ACMPlannedArray = ACMPlannedParts.split(';');
        ACMPlannedArray.map((value) => {
          plannedArr.push(value.split(','));
        });
      }
      const plannedValue = plannedArr.slice(0).map(
        ([productId, bodyComponent, confidence, isTemplated,
          shortDesc, longDesc]) => (
          {
            productId, bodyComponent, confidence, isTemplated, shortDesc, longDesc
          }
        )
      );
      const templatedPlannedData = [];
      for (const planned of plannedValue) {
        if (!_.isEmpty(planned.shortDesc)) {
          templatedPlannedData.push(planned);
        }
      }
      setAcmPlanned(templatedPlannedData);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  useEffect(async () => {
    try {
      await _getVhnPpcValue();
      await _getAcmPlanned();
      await _getDERFlagValue();

      const {
        territories,
        territoryId,
        selectedTeam,
        data
      } = props;

      territories.map((item) => {
        if (item.isFFF && item.id === territoryId) {
          if (item.hasOwnProperty('offices')) {
            item.offices.map((office) => {
              if (office.hasOwnProperty('teams')) {
                office.teams.map((team) => {
                  if (team.isFFF && team.id === selectedTeam.id) {
                    setIsFFFVisable(true);
                  }
                });
              }
            });
          }
        }
      });

      if (typeof data.CustomerNo !== 'undefined' && data.CustomerNo !== null) {
        const hosptalRes = await getHospitalByCustomerNo(data.CustomerNo);

        if (typeof hosptalRes !== 'undefined') {
          if (
            hosptalRes.UseCustCaseID === '1'
            && data.CustCaseID === null
            && (data.ProductSubmitted === null || data.ProductSubmitted !== '1')
          ) {
            setHospitalUseCustCaseIDStatus(true);
          }
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }, []);

  const _onProductClick = (id) => {
    try {
      const { addVhnPpc, setLoader } = props;
      setLoader(true);
      addVhnPpc(id);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onProductClickVras = (id) => {
    try {
      const { addVrasPpc, setLoader } = props;
      setLoader(true);
      addVrasPpc(id);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const onBeforeProduct = (e) => {
    const { setDerModal, data: { ProcedureType, id, DERRequired } } = props;
    const user = getUser();
    const territory = getTerritoryData(user);
    const location = window.location.href;
    if (territory
      && territory.isDER
      && id
      && typeof ProcedureType !== 'undefined'
      && ProcedureType !== null
      && ProcedureType.toUpperCase() === 'REVISION'
      && (DERRequired === null
        || DERRequired === undefined)
      && (location.includes('manage-cases')
        || location.includes('missing-dgr'))) {
      e.stopPropagation();
      setDerModal({ show: true, for: id });
      return;
    }
    onProduct(e);
  };

  const onProduct = (e = { stopPropagation: () => { } }) => {
    try {
      const {
        setTableName, table, online, notify,
        // data: { CaseScheduleID, DGR, CustCaseID },
        scanner, setProducts
      } = props;
      setProducts([]);
      setTableName(table);

      console.log(vhnValue);

      const resultedRoute = handleProductsButtonClick(
        online,
        // {
        //   CaseDate,
        //   CaseScheduleID,
        //   ACMCaseID,
        //   MRN,
        //   PatientID,
        //   CaseType,
        //   id,
        //   DGR,
        //   case_products,
        //   CreateRep,
        //   CustCaseID,
        //   ProductSubmitted
        // },
        props.data,
        CaseDate,
        {
          addPatientIdOrMrn: () => props.onMrnPatientIdAdd(id),
          addCustomerCaseID: () => props.onCustomerCaseAdd(id),
          addVhnPpc: () => _onProductClick(id),
          addVrasPpc: () => _onProductClickVras(id),
        },
        scanner,
        vhnValue.VHN_PPC,
        vhnValue.VHN_Other,
        vhnValue.VRAS_PPC,
        vhnValue.VRAS_Other,
        notify,
        hospitalUseCustCaseIDStatus
      );

      if (resultedRoute) {
        _onRedirect(e, resultedRoute);
      }
      e.stopPropagation();
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const _onXrays = (e) => {
    try {
      const { online, notify } = props;
      if (online) {
        _onRedirect(e, `/manage-case/${id}/x-ray`);
      } else {
        e.stopPropagation();
        notify({ type: 'error', message: 'X-rays cannot be views without an internet connection.', time: 2 });
      }
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const _onClickSets = (e) => {
    try {
      const { online, notify, data: { CaseScheduleID } } = props;
      if (online && CaseScheduleID === null) {
        e.stopPropagation();
        notify({ type: 'error', message: 'Case must be submitted and have a CaseNo before adding sets.', time: 2 });
      } else if (online && CaseScheduleID !== null) {
        _onRedirect(e, `/manage-case/${id}/sets`);
      } else {
        e.stopPropagation();
        notify({ type: 'error', message: 'You must be connected to the internet to view sets.', time: 2 });
      }
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const _preventParentClick = (e) => {
    try {
      e.stopPropagation();
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const _onOpenCaseMenu = (e) => {
    try {
      _preventParentClick(e);
      window.closeAllCasesMenu(window.$(e.target).attr('data-id'));
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const _onFilter = (event, key) => {
    try {
      if (key !== 'mix') {
        event.preventDefault();
        event.stopPropagation();
        const { onFilter } = props;
        if (onFilter) {
          props.onFilter({ [key]: event.target.value });
        }
      } else {
        const mix = {};
        mix.selectedTypes = event.CaseType;
        for (const filterValue in mix) {
          if (mix[filterValue] === null || mix[filterValue] === undefined || mix[filterValue] === '') {
            delete mix[filterValue];
          }
        }
        props.onFilter(mix);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onSideMenuPress = React.useCallback((event, key, index) => {
    try {
      if (key !== 'mix') {
        setActive(false);
        _onFilter(event, key);
        window.closeToggleMenu(event, `#cardMenu-${index}`);
      } else {
        setActive(false);
        _onFilter(event, key);
        window.closeToggleMenu(event, `#cardMenu-${index}`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }, []);

  const _onRedirectTo = (path) => {
    try {
      if (window.disabledClick) {
        return false;
      }
      const {
        onRedirect, setTableName, table
      } = props;
      setTableName(table);

      if (active) {
        onRedirect(path);
        setTableName(table);
      } else {
        setActive(true);
        setTableName(table);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onGoBack = () => {
    try {
      const { goBack, setGoBack } = props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onSubmitCase = async (event, index) => {
    try {
      const {
        data: { id }, team: { dgrRequired }, onSubmitCase, onCaseSubmitted, online,
        onShowDgrRequiredModal
      } = props;
      event.preventDefault();
      event.stopPropagation();
      window.closeToggleMenu(event, `#cardMenu-${index}`);

      const newUpdatedCaseDetail = await getTableCaseByCaseId(id, table);

      if (online && newUpdatedCaseDetail.case_products.length > 0
        && newUpdatedCaseDetail.ProductSubmitted === '0' && dgrRequired === 6 && newUpdatedCaseDetail.case_dgrs.length === 0) {
        onShowDgrRequiredModal(id);
        return;
      }

      (Submitted === '1' && ProductSubmitted === '1')
        ? onCaseSubmitted()
        // : (Submitted === '1' && Synced === '1' && ProductSubmitted === '1')
        //   ? onCaseSubmitted()
        : onSubmitCase(id);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onCancelCase = (e, index) => {
    try {
      const {
        online, notify, data: { id }, onCancel, onGetACMCase
      } = props;
      _preventParentClick(e);
      if (online) {
        onCancel(id);
        onGetACMCase(id);
      } else {
        window.closeToggleMenu(e, `#cardMenu-${index}`);
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const _onBilling = (e, index) => {
    try {
      const { onRedirect, notify, online } = props;
      _preventParentClick(e);
      if (online) {
        onRedirect(`/billing-detail/${id}`);
      } else {
        window.closeToggleMenu(e, `#cardMenu-${index}`);
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const _onDER = (e, index) => {
    try {
      const {
        onRedirect, setCaseDer, setTableName, table, setReadCaseData, data, setSelectCaseId
      } = props;
      setReadCaseData(data);
      setSelectCaseId(index);
      _preventParentClick(e);
      setCaseDer('true');
      setTableName(table);
      onRedirect(`/ders/search-ders/search-results/${id}`);
      window.closeToggleMenu(e, `#cardMenu-${index}`);
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const onSelectImage = async (formData) => {
    try {
      const {
        online, notify, setLoader, tableName, data: { id }
      } = props;
      const uploadFile = document.getElementById(`uploadDGREle-${id}`);
      const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
      console.log(caseChangesNoLonger);
      // if (caseDetailsRes && caseDetailsRes.DGR === '1') {
      //   caseChangesNoLonger.show();
      //   return;
      // }

      const body = formData.files[0];
      if (!(/\.(gif|jpg|jpeg|tiff|png|pdf|heic)$/i).test(body.name)) {
        notify({ type: 'error', message: 'Only images and PDF files are allowed for DGR uploads.' });
        return;
      }
      setLoader(true);
      if (online) {
        uploadDgr({
          CaseScheduleID: caseDetailsRes.CaseScheduleID,
          OriginalFile: body
        }).then(async (responseJson) => {
          setLoader(false);
          const {
            message, data, result
          } = responseJson;
          if (result === 'success') {
            if (message.length > 0) {
              uploadFile.value = null;
            }
            _onGoBack();
            // Update into local db
            caseDetailsRes.case_dgrs.push(data);
            caseDetailsRes.DGRUpload = '2';
            caseDetailsRes.ProductSubmitted = '0';
            await updateCase(caseDetailsRes);
            await updateTableWiseCaseByCaseId(caseDetailsRes.RepCaseNo, caseDetailsRes, tableName);
            setLoader(false);
          } else if (result === 'failure') {
            notify({ type: 'error', message });
            setLoader(false);
          } else {
            notify({ type: 'error', message });
            setLoader(false);
          }
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const onRedirectToDgr = () => {
    try {
      setTimeout(() => {
        const {
          goBack, setGoBack, setLoader, data: { id }
        } = props;
        const uploadFile = document.getElementById(`uploadDGREle-${id}`);
        setLoader(true);
        _onGoBack();
        if (uploadFile !== null && uploadFile.value.length) {
        } else {
          if (goBack.length === 2 && goBack[goBack.length - 2] === '/manage-cases') {
            setGoBack('/manage-cases');
            return;
          }
          if (goBack.length === 3) {
            if (goBack[goBack.length - 2] === '/missing-dgr') {
              setGoBack(['/billing', '/missing-dgr']);
              return;
            } if (goBack[goBack.length - 2] === '/missing-pos') {
              setGoBack(['/billing', '/missing-pos']);
              return;
            } if (goBack[goBack.length - 2] === '/billing/notBilledCases') {
              setGoBack(['/billing', '/billing/notBilledCases']);
              return;
            }
          }
          if (goBack.length === 4 && goBack[goBack.length - 1] === '/manage-cases/filter-cases') {
            setGoBack(['/manage-cases', '/manage-cases/filter', '/manage-cases/filter-cases']);
            return;
          }
          browserHistory.push(`/manage-case/${id}/products/dgr`);
          setLoader(false);
        }
        document.body.onfocus = null;
      }, 1000);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const onCancelUploadImage = () => {
    try {
      const { setLoader } = props;
      setLoader(true);
      document.body.onfocus = onRedirectToDgr;
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onAcmflags = (e) => {
    try {
      _onRedirect(e, `/manage-case/${id}/acm-products/acmFlagDetails`);
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const _onAcmDollar = (e) => {
    try {
      const { online, notify } = props;
      if (online) {
        _onRedirect(e, `/billing-detail/${id}`);
      } else {
        e.stopPropagation();
        notify({ type: 'error', message: 'You must be connected to the internet to view billing details.', time: 2 });
      }
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const _onACMPushCase = (e, index) => {
    try {
      const {
        online,
        notify,
        onACMPushCase
      } = props;

      _preventParentClick(e);
      if (online) {
        window.closeToggleMenu(event, `#cardMenu-${index}`);
        onACMPushCase(id);
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const onSubmitDer = async () => {
    try {
      const {
        data: { id }, team: { dgrRequired }, onSubmitCase, onCaseSubmitted, online
      } = props;
      const newUpdatedCaseDetail = await getTableCaseByCaseId(id, table);

      if (online && newUpdatedCaseDetail.case_products.length > 0
        && ProductSubmitted === '0' && dgrRequired === 6 && newUpdatedCaseDetail.case_dgrs.length === 0) {
        return;
      }

      (Submitted === '1' && ProductSubmitted === '1')
        ? onCaseSubmitted()
        // : (Submitted === '1' && Synced === '1' && ProductSubmitted === '1')
        //   ? onCaseSubmitted()
        : onSubmitCase(id);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onEditedCase = async (event, index) => {
    try {
      const {
        data: { id, CaseDate },
        online,
        goBack,
        tableName,
        setSelectCaseDate,
        setGoBack,
        notify
      } = props;
      event.preventDefault();
      event.stopPropagation();
      window.closeToggleMenu(event, `#cardMenu-${index}`);

      if (online) {
        goBack.push(window.location.pathname);

        browserHistory.push(`/manage-case/${id}/edit`);
        if (tableName === 'Cases') {
          setSelectCaseDate(new Date(CaseDate.replace(/-/g, '/')));
        }
        setGoBack(goBack);
      } else if (!moment(CaseDate, 'YYYY-MM-DD').isSameOrBefore()) {
        notify({ type: 'error', message: 'This case can no longer be edited while offline.' });
      } else {
        // this.patientAndMrnEditOfflineModal.show();
      }

      if (tableName === 'Cases') {
        setSelectCaseDate(new Date(CaseDate.replace(/-/g, '/')));
      }

      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  useEffect(() => {
    const {
      derModal, data, setDerModal, setLoader, online, tableName, onRefreshDate
    } = props;
    if (derModal.answer && derModal.for === data.id) {
      const handleModalAnswer = async () => {
        const updatedCase = {
          ...data,
          DERRequired: derModal.answer.toUpperCase() === 'YES' ? '1' : '0'
        };
        if (online) {
          await updateCase(updatedCase).finally(() => setLoader(false));
          setDerModal({ ...derModal, answer: null, for: null });
          updateTableWiseCaseByCaseId(updatedCase.RepCaseNo, updatedCase, tableName);
        } else {
          updatedCase.Sync = 1;
          updateTableWiseCaseByCaseId(updatedCase.RepCaseNo, updatedCase, tableName);
        }
        if (onRefreshDate) {
          await onRefreshDate(new Date(updatedCase.CaseDate));
        }
        onProduct();
        setDerModal({ ...derModal, answer: null, for: null });
      };
      setLoader(true);
      handleModalAnswer().finally(() => setLoader(false));
    }
  }, [props.derModal]);

  const {
    smallLargeCard,
    isCancel = true,
    type,
    data: {
      ACMCaseID,
      SurgeonName,
      CustomerName,
      PatientID,
      CoverRep,
      CaseType,
      AltCaseType,
      Side,
      ProcedureType,
      RepCaseNo,
      CaseNo,
      Submitted,
      id,
      case_products,
      case_xrays,
      ProductSubmitted,
      case_sets,
      CaseDate,
      MRN, POIssue, CaseTime,
      PriceSheet,
      ACMCaseFlags,
      Gender,
      FFFValue,
      RepNotes,
      CreateRep,
      ACMCaseID2
    },
    team: { salesAccess },
    table,
    isGroup,
    screenWidth,
    filterCase,
    themeColor,
  } = props;

  let setsQuantity = 0;
  if (case_sets !== undefined) {
    setsQuantity = case_sets.reduce((sum, { Quantity }) => sum + parseInt(Quantity, 10), 0);
  }

  const ShowPushACM = (ACMCaseID2 !== null && CreateRep !== 'ACM');
  const ShowACM = (ACMCaseID !== null && CreateRep === 'ACM');

  return (
    <>
      <input
        id={`uploadDGREle-${id}`}
        accept="image/*,.pdf"
        type="file"
        capture="capture"
        onClick={onCancelUploadImage}
        onChange={(e) => onSelectImage(e.target)} className="d-none"
      />
      <div className="col-12 col-md-12 cursor-pointer">
        <div className={`card-block ${smallLargeCard ? 'small-card' : ''}`} onClick={() => _onRedirectTo(`/manage-case/${id}`)}>
          <div className={`card-block-header ${isGroup === false ? 'card-header-height' : ''}`}>
            <div className={`row ${smallLargeCard ? 'small-card-row' : ''}`}>
              <div className={`${smallLargeCard ? 'col-9' : 'col-8'} pe-0 align-self-center ${isGroup === false ? 'mb-3' : ''}`}>
                <span className="time">
                  {
                    type === 'caseCard'
                      ? moment(CaseTime, ['HH:mm']).format('h:mm A')
                      : type === 'billedCaseRow'
                        ? moment(CaseDate).format('MMM DD, YYYY')
                        : moment(CaseDate, ['YYYY-MM:DD']).format('DD MMM YY')
                  }
                </span>

                {
                  !(Submitted === '1' && (ProductSubmitted === '1' || ProductSubmitted === null))
                    ? (
                      <span
                        className={
                          `text-red acmflagbtn fixed-space ${screenWidth < 800 ? 'px-0' : 'px-2'}`
                        }
                        onClick={
                          (e) => _onSubmitCase(e, id)
                        }
                      >
                        <img width="24px" src={ArrowRight} alt="arrow" />
                      </span>
                    )
                    : <span className={`acmflagbtn fixed-space ${screenWidth < 800 ? 'px-0' : 'px-2'}`} />
                }

                {
                  (props.data.hasOwnProperty('case_xrays') && case_xrays.length > 0)
                    ? (
                      <span className={`x-raybtn acmflagbtn fixed-space ${screenWidth < 800 ? 'px-0' : 'px-2'}`}>
                        <Link className="redirectLink 3" onClick={(e) => _onXrays(e)}>
                          <img width="20px" src={XrayIcon} alt="xray" />
                        </Link>
                      </span>
                    )
                    : <span className={`acmflagbtn fixed-space ${screenWidth < 800 ? 'px-0' : 'px-2'}`} />
                }

                {
                  (PriceSheet !== null && PriceSheet !== undefined && PriceSheet !== '' && PriceSheet !== '0')
                    ? (
                      <span className={`acmflagbtn fixed-space ${screenWidth < 800 ? 'px-0' : 'px-2'}`}>
                        <Link className="redirectLink 4" onClick={(e) => _onAcmDollar(e)}>
                          <img width="15px" src={DollarSign} alt="flag" />
                        </Link>
                      </span>
                    )
                    : <span className={`acmflagbtn fixed-space ${screenWidth < 800 ? 'px-0' : 'px-2'}`} />
                }

                {
                  (isFFFVisable && FFFValue !== null && FFFValue !== undefined && FFFValue !== '' && FFFValue === 'CONFIRMED')
                    ? (
                      <span className={`acmflagbtn fixed-space ${screenWidth < 800 ? 'px-0' : 'px-2'}`} style={{ cursor: 'auto' }}>
                        <img width="25px" src={themeColor === 'light' ? FFFIconDark : FFFIcon} alt="FFF" />
                      </span>
                    )
                    : <span className={`acmflagbtn fixed-space ${screenWidth < 800 ? 'px-0' : 'px-2'}`} />
                }

                {
                  (smallLargeCard && screenWidth < 800)
                    ? (
                      <>
                        {
                          ShowPushACM && (
                            <span className={`acmflagbtn ${screenWidth < 800 ? 'px-0' : 'px-2'}`}>
                              <img width="14px" src={themeColor === 'light' ? ACMRightArrowDark : ACMRightArrow} alt="flag" />
                              <span className="px-1 position-relative" style={{ top: '1px', fontSize: '12px' }}>ACM</span>
                            </span>
                          )
                        }

                        {
                          ShowACM && (
                            PatientID !== null && PatientID.startsWith('ACM CX')
                              ? <span className="acmflagbtn fixed-space" style={{ color: 'red' }}>ACM</span>
                              : (ACMCaseFlags !== null && ACMCaseFlags !== undefined && ACMCaseFlags !== '')
                                ? (
                                  <span className={`acmflagbtn fixed-space ${screenWidth < 800 ? 'px-0' : 'px-2'}`}>
                                    <Link className="redirectLink 1" onClick={(e) => _onAcmflags(e)}>
                                      <img width="20px" src={AcmFlag} alt="flag" />
                                    </Link>
                                  </span>
                                )
                                : (
                                  <span className={`acmflagbtn ${screenWidth < 800 ? 'px-0' : 'px-2'}`} style={{ position: 'relative', top: '2px' }}>ACM</span>
                                )
                          )
                        }
                      </>
                    ) : (
                      ACMCaseFlags !== null && ACMCaseFlags !== undefined && ACMCaseFlags !== ''
                    ) && (
                      <span className={`acmflagbtn fixed-space ${screenWidth < 800 ? 'px-0' : 'px-2'}`}>
                        <Link className="redirectLink 2" onClick={(e) => _onAcmflags(e)}>
                          <img width="20px" src={AcmFlag} alt="flag" />
                        </Link>
                      </span>
                    )
                }

                {/* Small Card Start ACM */}
                {
                  smallLargeCard && screenWidth > 800 && (
                    <>
                      {
                        ShowPushACM && (
                          <>
                            <span className="fixed-space">
                              <img width="18px" src={themeColor === 'light' ? ACMRightArrowDark : ACMRightArrow} alt="flag" />
                            </span>
                            <span className="acmflagbtn web-view">
                              ACM
                            </span>
                          </>
                        )
                      }

                      {
                        ShowACM && (
                          <span className={`acmflagbtn ${screenWidth < 800 ? 'px-0' : 'px-2'} web-view`} style={PatientID !== null && PatientID.startsWith('ACM CX') ? { color: 'red' } : {}}>
                            ACM
                          </span>
                        )
                      }
                    </>
                  )
                }
                {/* Small Card End ACM */}
              </div>

              <div className={`col text-end ${screenWidth < 800 ? 'ps-0' : ''}`}>
                <div className="dropdown mobileView d-flex justify-content-between align-items-center">
                  {/* Web View Start */}
                  <div className="web-view webViewACM">
                    <span className="fixed-space">
                      {
                        CaseNo === null ? 'PENDING' : CaseNo.slice(3)
                      }
                    </span>

                    {
                      ShowPushACM && !smallLargeCard && (
                        <span className="fixed-space">
                          <img width="18px" src={themeColor === 'light' ? ACMRightArrowDark : ACMRightArrow} alt="flag" />
                          <span className="px-2 position-relative" style={{ top: '2px' }}>
                            ACM
                          </span>
                        </span>
                      )
                    }

                    {
                      ShowACM && !smallLargeCard && (
                        <span className={`fixed-space ${ShowPushACM} ${smallLargeCard}`}>
                          {
                            (ACMCaseID !== null)
                              ? PatientID !== null && PatientID.startsWith('ACM CX')
                                ? <span style={{ color: 'red' }}> ACM</span>
                                : <span> ACM</span>
                              : <span />
                          }
                        </span>
                      )
                    }
                  </div>
                  {/* Web View End */}

                  {/* App View Start */}
                  <div className="mobile-view">
                    <span className="fixed-space">
                      {
                        CaseNo === null ? 'PENDING' : CaseNo.slice(3)
                      }
                    </span>

                    {
                      ShowPushACM && !smallLargeCard && (
                        <span className="fixed-space">
                          <img width="18px" src={themeColor === 'light' ? ACMRightArrowDark : ACMRightArrow} alt="flag" />
                          <span className="px-2">
                            ACM
                          </span>
                        </span>
                      )
                    }

                    {
                      ShowACM && !smallLargeCard && (
                        <span className={`fixed-space ${ShowPushACM} ${smallLargeCard}`}>
                          {
                            (ACMCaseID !== null)
                              ? PatientID !== null && PatientID.startsWith('ACM CX')
                                ? <span style={{ color: 'red' }}> ACM</span>
                                : <span> ACM</span>
                              : <span />
                          }
                        </span>
                      )
                    }
                  </div>
                  {/* App View End */}

                  <Link
                    onClick={(e) => { _onOpenCaseMenu(e); }}
                    className="dropdown-toggle"
                    role="button"
                    id={`cardMenu-${id}`}
                    data-id={`cardMenu-${id}`}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                    <img
                      onClick={(e) => { _onOpenCaseMenu(e); }}
                      data-id={`cardMenu-${id}`}
                      src={threeDot} alt="ThreeDot"
                      width={`${(screenWidth < 800 || screenWidth < 836) ? '23' : '35'}`}
                      onError={(event) => {
                        event.target.src = '/assets/images/three-dots.svg';
                        event.onerror = null;
                      }}
                    />
                  </Link>

                  <ul
                    className={`dropdown-menu  ${table === 'Billed' && type === 'billedCaseRow' ? 'dropdown-menu-billedCaseRow' : ''} ${(table === 'MissingPos' || table === 'NotBilled') && type === 'billedCaseRow' ? 'dropdown-menu-missingPosCaseRow' : ''} ${typeof filterCase !== 'undefined' && filterCase === 'filterCase' ? 'dropdown-menu-filterCaseRow' : ''}`}
                    aria-labelledby={`cardMenu-${id}`}
                  >
                    <li>
                      <Link
                        className="close-dropdown cursor-pointer"
                        data-toggle="dropdown" data-bind="enable: !noResults()"
                        onClick={(e) => window.closeToggleMenu(e, `#cardMenu-${id}`)}
                      ><i className="fas fa-times" />
                      </Link>
                      <button className="dropdown-item" style={{ width: '110px' }} onClick={(e) => _onSubmitCase(e, id)}>
                        Submit
                      </button>
                    </li>

                    <li>
                      <button className="dropdown-item" style={{ width: '110px' }} onClick={(e) => _onEditedCase(e, id)}>
                        Edit Case
                      </button>
                    </li>

                    {
                      isCancel && (
                        <li>
                          <Link
                            className="dropdown-item cursor-pointer"
                            onClick={(e) => _onCancelCase(e, id)}
                          >Cancel Case
                          </Link>
                        </li>
                      )
                    }

                    {
                      salesAccess && (
                        <li>
                          <Link
                            className="dropdown-item cursor-pointer"
                            onClick={(e) => _onBilling(e, id)}
                          >
                            Billing Details
                          </Link>
                        </li>
                      )
                    }

                    {
                      isDER === true && (
                        <li>
                          <Link
                            className="dropdown-item cursor-pointer"
                            onClick={(e) => _onDER(e, id)}
                          >
                            DER
                          </Link>
                        </li>
                      )
                    }

                    {
                      CreateRep !== 'ACM' && (
                        <li>
                          <Link
                            className="dropdown-item cursor-pointer"
                            onClick={(e) => _onACMPushCase(e, id)}
                          >ACM Push
                          </Link>
                        </li>
                      )
                    }

                    <li>
                      <span
                        className="dropdown-item"
                        onClick={_preventParentClick}
                      >
                        Quick Filters
                      </span>
                    </li>

                    <li>
                      <button
                        className="dropdown-item sub-link cursor-pointer"
                        value={SurgeonName}
                        onClick={(event) => { _onSideMenuPress(event, 'selectSurgeon', id); }}
                      >Surgeon
                      </button>
                    </li>

                    <li>
                      <button
                        className="dropdown-item sub-link cursor-pointer"
                        value={CustomerName}
                        onClick={(event) => { _onSideMenuPress(event, 'selectHospitals', id); }}
                      >Hospital
                      </button>
                    </li>

                    <li>
                      <button
                        className="dropdown-item sub-link cursor-pointer"
                        value={PatientID}
                        onClick={(event) => { _onSideMenuPress(event, 'PatientID', id); }}
                      >Patient Name
                      </button>
                    </li>

                    <li>
                      <button
                        className="dropdown-item sub-link cursor-pointer"
                        value={CoverRep}
                        onClick={(event) => { _onSideMenuPress(event, 'selectedRefs', id); }}
                      >Rep Name
                      </button>
                    </li>

                    <li>
                      <button
                        className="dropdown-item sub-link cursor-pointer"
                        value={AltCaseType}
                        onClick={(event) => { _onSideMenuPress(event, 'selectedTypes', id); }}
                      >Type
                      </button>
                    </li>

                    <li>
                      {
                        (table === 'Cases')
                          ? (
                            <button
                              className="dropdown-item sub-link cursor-pointer"
                              value={ProcedureType}
                              onClick={(event) => { _onSideMenuPress(event, 'ProcedureType', id); }}
                            >Procedure
                            </button>
                          )
                          : (
                            <button
                              className="dropdown-item sub-link cursor-pointer"
                              value={ProcedureType}
                              onClick={(event) => { _onSideMenuPress(event, 'selectedProcedures', id); }}
                            >Procedure
                            </button>
                          )
                      }
                    </li>

                    <li>
                      <button
                        className="dropdown-item sub-link cursor-pointer"
                        value={Side}
                        onClick={(event) => { _onSideMenuPress(event, 'Side', id); }}
                      >Side
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="card-block-body pt-0">
            <div className="row gx-2">
              <div
                className={`${((isGroup === undefined && !smallLargeCard)
                  || (isGroup === false && !smallLargeCard)
                  || (isGroup === false && smallLargeCard)
                  || (type === undefined && isGroup === undefined && smallLargeCard === true && screenWidth > 375)) ? 'col-8'
                  : (type === undefined && isGroup === undefined && smallLargeCard === true && screenWidth < 375) ? 'col-8 small-card-view'
                    : (smallLargeCard && isGroup === undefined && type === 'caseCard') ? 'col-4' : 'col-8 col-md-6'}`}
              >
                {
                  (type !== 'caseCard' && type !== 'billedCaseRow')
                    ? (
                      (type === undefined && smallLargeCard === false) ? (
                        <div className="col-12 c0">
                          <span>
                            <p className={`${screenWidth < 800 ? 'mobile-hospital-text-overflow' : 'desktop-hospital-text-overflow'}`}>
                              {CustomerName}
                            </p>
                          </span>
                        </div>
                      ) : (type === undefined && smallLargeCard === true)
                        ? ''
                        : (
                          <div className="col-12 c1">
                            <span>{CustomerName}</span>
                          </div>
                        )
                    ) : ((type === 'caseCard' || type === 'billedCaseRow') && isGroup !== undefined && !smallLargeCard)
                      ? (
                        <div className="col-12 c2">
                          <span>
                            <p className={`${screenWidth < 800 ? 'mobile-hospital-text-overflow' : 'desktop-hospital-text-overflow'}`}>
                              {CustomerName}
                            </p>
                          </span>
                        </div>
                      )
                      : ''
                }
                {
                  (type === undefined && smallLargeCard === false && CustomerName === null)
                  && (
                    <div className="col-12 text-ellipsis">
                      <span className="repTitle">Hospital</span>
                    </div>
                  )
                }
                {
                  smallLargeCard
                    ? (
                      <div className="row gx-2">
                        <div className={`col-5 ${screenWidth < 800 ? 'mobile-text-overflow-case-card' : 'desktop-text-overflow-case-card'}`}>
                          {SurgeonName}
                        </div>

                        {
                          ((type === 'caseCard' && isGroup !== undefined) || (type === undefined && smallLargeCard === true))
                            ? (
                              <div className={`col-6 ${screenWidth < 800 ? 'mobile-text-overflow-case-card' : 'desktop-text-overflow-case-card'}`}>
                                {CustomerName}
                              </div>
                            ) : ''
                        }
                      </div>

                    )
                    : (
                      <div className="col-12 text-ellipsis">
                        {SurgeonName != null ? SurgeonName : <span className="repTitle">Surgeon</span>}
                      </div>
                    )
                }

                <div className="col-12 bottom-row">
                  <div className="col-12">
                    {
                      (PatientID !== null && PatientID !== undefined && PatientID !== '')
                        ? (
                          <p className={`my-0 text-overflow-case-row ${PatientID.startsWith('ACM CX') ? 'acm-cx-bg' : ''}`}>
                            <span className={`p-name text-uppercase ${PatientID.startsWith('ACM CX') ? 'bg-red' : 'bg-transparent'}`}>
                              {PatientID} {Gender ? `(${Gender[0]})` : null} {MRN ? `- ${MRN}` : null}
                            </span>
                          </p>
                        )
                        : (
                          Gender
                            ? (
                              <p className="my-0 text-overflow-case-row">
                                <span className="p-name text-uppercase">
                                  ({Gender[0]}) {MRN ? `- ${MRN}` : null}
                                </span>
                              </p>
                            ) : (
                              MRN
                                ? (
                                  <p className="my-0 text-overflow-case-row">
                                    <span className="p-name text-uppercase">
                                      {MRN ? `${MRN}` : null}
                                    </span>
                                  </p>
                                ) : (
                                  <p className="my-0">
                                    <span className="repTitle">Patient</span>
                                  </p>
                                )
                            )
                        )
                    }
                  </div>
                  <div className="col-12">
                    {
                      (CoverRep !== null && CoverRep !== undefined && CoverRep !== '')
                        ? <p className="my-0"><span className="p-name text-uppercase">{CoverRep}</span></p>
                        : <p className="my-0"><span className="repTitle">Rep</span></p>
                    }
                  </div>
                  <div className="col-12">
                    <span className="repDesc">
                      {AltCaseType !== null
                        ? `${AltCaseType.toString()}`
                        : !CaseType ? null : `${CaseType.toString()}`}
                      {ProcedureType === null || AltCaseType
                        ? null
                        : `, ${ProcedureType.toString()}`}
                      {!Side
                        ? null
                        : `, ${Side.toString()}`}
                    </span>
                  </div>
                  <div className="col-12 acm-templated-desc">
                    {
                      ACMCaseID !== null && acmPlanned.map((data, key) => (
                        <span className="repDesc" key={key}>
                          {key !== 0 ? `, ${data.shortDesc}` : data.shortDesc}
                        </span>
                      ))
                    }
                  </div>
                </div>
              </div>
              <div
                className={`mt-auto ${((isGroup === undefined && !smallLargeCard)
                  || (isGroup === false && !smallLargeCard)
                  || (isGroup === false && smallLargeCard)
                  || (type === undefined && isGroup === undefined && smallLargeCard === true && screenWidth > 375)) ? 'col-4'
                  : (type === undefined && isGroup === undefined && smallLargeCard === true && screenWidth < 375) ? 'col-4 small-card-view'
                    : (smallLargeCard && isGroup === undefined && type === 'caseCard') ? 'col-8'
                      : 'col-4 col-md-6'}`}
              >
                {
                  ((type !== undefined && isGroup === undefined)
                    || (type === undefined && isGroup === undefined && !smallLargeCard))
                  && (
                    <div className="right-link small-show">
                      {AltCaseType !== null
                        ? `${AltCaseType.toString()}`
                        : !CaseType ? null : `${CaseType.toString()}`}
                      {ProcedureType === null || AltCaseType
                        ? null
                        : `, ${ProcedureType.toString()}`}
                      {!Side
                        ? null
                        : `, ${Side.toString()}`}
                    </div>
                  )
                }

                {
                  ((smallLargeCard && isGroup !== undefined)
                    || (type === undefined && smallLargeCard === true))
                  && (
                    <a className="right-link small-show 456">
                      {AltCaseType === null ? (
                        <>
                          {CaseType === null ? null : `${CaseType.toString().substring(0, 1)}`}
                          {ProcedureType === null ? null : `-${ProcedureType.toString().substring(0, 1)}`}
                        </>
                      ) : `${AltCaseType.toString().substring(0, 1)}`}
                      {Side === null ? <span style={{ visibility: 'hidden' }}>-N</span>
                        : (Side === 'NONE') ? <span style={{ visibility: 'hidden' }}>-N</span>
                          : `-${Side.toString().substring(0, 1)}`}
                    </a>
                  )
                }
                <div className="bottom-btn bottom-row">
                  <div className="col">
                    <Link className="btn btn-theme-alt btn-theme-outline-alt bg-card d-block" onClick={(e) => _onClickSets(e)}>
                      {props.data.hasOwnProperty('SetQty') && `${(setsQuantity === 0 || setsQuantity === null)
                        ? `${setsQuantity} Sets` : (setsQuantity === 1)
                          ? `${setsQuantity} Set`
                          : `${setsQuantity} Sets`}`}
                    </Link>
                  </div>
                  <div className="col my-2">
                    <Link
                      className="btn btn-theme-alt btn-theme-outline-alt bg-card d-block"
                      onClick={(e) => onBeforeProduct(e)}
                    >
                      {
                        props.data.hasOwnProperty('case_products') && `${case_products.length === 0
                          ? `${case_products.length} Products` : `${case_products.length === 1
                            ? `${case_products.length} Product` : `${case_products.length} Products`}`}`
                      }
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {
              (typeof RepNotes !== 'undefined' && RepNotes !== null && RepNotes !== '')
                ? (
                  <div className="mt-2 bottom-row truncate" style={{ maxWidth: '100%' }}>
                    {RepNotes}
                  </div>
                ) : ''
            }
            {
              (table === 'NotBilled' && POIssue === '1')
                ? (
                  <div className="mt-2">
                    <span style={{ color: '#ff0000', display: 'none' }}>*There is an issues with this PO</span>
                  </div>
                ) : ''
            }
          </div>
        </div>
      </div>

      <CaseChangesNoLonger id={id} />

      <DerSubmit
        title="Submit Case"
        text="Are you sure you want to submit this case?"
        onClickYes={() => onSubmitDer(props.data)} id={RepCaseNo}
      />
    </>
  );
};

export default withGoBack(
  withProducts(
    withOnline(
      withTableName(
        withNotify(
          withLoader(
            withTeam(
              withCaseDer(
                withDerModal(
                  withReadCaseData(
                    withSelectCaseId(
                      withThemeColor(
                        CaseRow
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
